export default __webpack_public_path__ + "fr/static/media/picto_colissimo.d39518b6.svg";